export const loadTealium = () => {
  const apiUrl = window.__env__.API_URL;
  if (apiUrl && window.self === window.top && !window.location.pathname.startsWith('/internal/workspaces')) {
    const isStaging = apiUrl.indexOf('staging') !== -1;

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = `https://tags.tiqcdn.com/utag/sage/futrli/${isStaging ? 'dev' : 'prod'}/utag.js`;
    const el = document.getElementsByTagName('script')[0];
    el.parentNode?.insertBefore(script, el);

    (() => {
      const src = `https://tags.tiqcdn.com/utag/sage/futrli/${isStaging ? 'dev' : 'prod'}/utag.js`;
      const documentRef = document;
      const scriptTag = 'script';

      const newScript: HTMLScriptElement = documentRef.createElement(scriptTag);
      newScript.src = src;
      newScript.type = 'text/javascript';
      newScript.async = true;
      const firstScript = documentRef.getElementsByTagName(scriptTag)[0];
      firstScript.parentNode?.insertBefore(newScript, firstScript);
    })();
  }
};

export const loadTealiumSync = () => {
  const apiUrl = window.__env__.API_URL;
  if (window.self === window.top && !window.location.pathname.startsWith('/internal/workspaces')) {
    const isStaging = apiUrl.indexOf('staging') !== -1;
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = `https://tags.tiqcdn.com/utag/sage/futrli/${isStaging ? 'dev' : 'prod'}/utag.sync.js`;
    const el = document.getElementsByTagName('script')[0];
    el.parentNode?.insertBefore(script, el);
  }
};
